import domReady from '@wordpress/dom-ready';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import { tablet } from './../settings';
gsap.registerPlugin(ScrollTrigger);

domReady(() => {
	const sections = document.querySelectorAll('.section');
	if (sections && sections.length) {
		sections.forEach((block) => {
			const sectionCurve = block.querySelector('.curve-inner');
			if (sectionCurve) {
				let mm = gsap.matchMedia();

				mm.add(`(min-width: ${tablet}px)`, () => {
					gsap.timeline({}).from(sectionCurve, {
						height: 0,
						scrollTrigger: {
							trigger: sectionCurve,
							toggleActions: 'play pause reverse pause',
							start: 'bottom bottom',
							end: 'bottom 25%',
							scrub: 0.5,
						},
					});
				});
			}
		});
	}
});
